import React from 'react';
import moment from 'moment';

import { QuestionYearDefaultProps, QuestionYearPropTypes } from 'src/components/JobDatasheet/propTypes';
import { DatePickerField } from 'src/components/DatePickerField/DatePickerField';

export const QuestionYear = ({
  errors,
  flash,
  isRectifiedQuestion,
  onChange,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const yearsToDisplayInFuture = 26;
  const currentDate = new Date();
  const futureDateUpto26 = new Date(currentDate);
  futureDateUpto26.setFullYear(currentDate.getFullYear() + yearsToDisplayInFuture);

  const getReturnObject = val => {
    const returnObject = {
      ...value,
      type: 'year'
    };
    returnObject[selectedValueKey] = val ? Number.parseInt(moment(val).format('YYYY'), 10) : null;

    return returnObject;
  };
  
  return (
    <DatePickerField
      dateOnly
      error={(errors || []).join(' & ')}
      flash={flash}
      fullsize
      yearOnly
      onChange={!disableChange && ((v) => onChange(getReturnObject(v)))}
      value={value ? value[selectedValueKey] : ''}
      popperPlacement={'bottom-start'}
      maxDate={futureDateUpto26}
    />
  );
};

QuestionYear.propTypes = QuestionYearPropTypes;
QuestionYear.defaultProps = QuestionYearDefaultProps;
